export const rolesOptions = [
  { value: 'admin', label: 'Admin' },
  { value: 'coordinator', label: 'Koordynator' },
];
